import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AdminSharedModule } from '@modules/admin-shared/admin-shared.module';
import { InventoryModule } from '@modules/inventory/inventory.module';
import { ImageModule } from '@components/admin/image/image.module';
import { ManagedBoardComponent } from '@components/admin/managed-board/managed-board.component';
import { ManagedBoardInventoryComponent } from '@components/admin/managed-board/managed-board-inventory/managed-board-inventory.component';
import { ManagedBoardJobReadyComponent } from '@components/admin/managed-board/managed-board-job-ready/managed-board-job-ready.component';
import { ManagedBoardAwaitingFramesComponent } from '@components/admin/managed-board/managed-board-awaiting-frames/managed-board-awaiting-frames.component';
import { ManagedBoardStackComponent } from '@components/admin/managed-board/managed-board-stack/managed-board-stack.component';
import { StackOrdersComponent } from '@components/admin/managed-board/managed-board-stack/stack-orders/stack-orders.component';
import { StackInquiriesComponent } from '@components/admin/managed-board/managed-board-stack/stack-inquiries/stack-inquiries.component';
import { StackVendorsComponent } from '@components/admin/managed-board/managed-board-stack/stack-vendors/stack-vendors.component';
import { StackTodoTodayComponent } from '@components/admin/managed-board/managed-board-stack/stack-todo-today/stack-todo-today.component';
import { AwaitingFramesOrdersComponent } from '@components/admin/managed-board/managed-board-awaiting-frames/awaiting-frames-orders/awaiting-frames-orders.component';
import { AwaitingFramesSubmitComponent } from '@components/admin/managed-board/managed-board-awaiting-frames/awaiting-frames-submit/awaiting-frames-submit.component';
import { ReturnsComponent } from '@components/admin/managed-board/returns/returns.component';
import { ReturnsOrdersComponent } from '@components/admin/managed-board/returns/returns-orders/returns-orders.component';
import { ReturnsSubmitComponent } from '@components/admin/managed-board/returns/returns-submit/returns-submit.component';
import { ReturnsSentComponent } from '@components/admin/managed-board/returns/returns-sent/returns-sent.component';
import { BorrowingComponent } from '@components/admin/managed-board/borrowing/borrowing.component';
import { BorrowingProductsComponent } from '@components/admin/managed-board/borrowing/borrowing-products/borrowing-products.component';
import { BorrowingVendorsComponent } from '@components/admin/managed-board/borrowing/borrowing-vendors/borrowing-vendors.component';
import { BorrowingOrdersComponent } from '@components/admin/managed-board/borrowing/borrowing-orders/borrowing-orders.component';
import { ManagedBoardInvoiceComponent } from '@components/admin/managed-board/invoice/invoice.component';
import { ManagedBoardCreditComponent } from '@components/admin/managed-board/credit/credit.component';
import { CustomerNotifyDialogComponent } from '@components/admin/patient/customer-notify-dialog.component';

const BOARD_DECLARATIONS = [
  ManagedBoardComponent,
  ManagedBoardInventoryComponent,
  ManagedBoardJobReadyComponent,
  ManagedBoardAwaitingFramesComponent,
  ManagedBoardStackComponent,
  StackOrdersComponent,
  StackInquiriesComponent,
  StackVendorsComponent,
  StackTodoTodayComponent,
  AwaitingFramesOrdersComponent,
  AwaitingFramesSubmitComponent,
  ReturnsComponent,
  ReturnsOrdersComponent,
  ReturnsSubmitComponent,
  ReturnsSentComponent,
  BorrowingComponent,
  BorrowingProductsComponent,
  BorrowingVendorsComponent,
  BorrowingOrdersComponent,
  ManagedBoardInvoiceComponent,
  ManagedBoardCreditComponent,
  CustomerNotifyDialogComponent,
];

@NgModule({
  declarations: BOARD_DECLARATIONS,
  imports: [AdminSharedModule, InventoryModule, ImageModule],
  exports: BOARD_DECLARATIONS,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  entryComponents: [CustomerNotifyDialogComponent],
})
export class BoardModule {}
